import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';
import CSSModules from 'react-css-modules';

import * as visitTypes from '../../../redux/appointmentForm/requests/visit-types-req';
import * as reasonTypes from '../../../redux/appointmentForm/requests/reason-types-req';
import * as createVirtualVisit from '../../../redux/appointmentForm/requests/create-virtual-visit-req';
import { actions as reqProviders } from '../../../redux/appointmentForm/requests/virtual-visit-providers-req';
import {
  selectVirtualVisitServicesList,
  selectVisitTypesPending,
  selectReasonTypesList,
  selectReasonTypesPending,
  selectVirtualVisitProvidersList,
  selectVirtualVisitProvidersPending,
  selectCreateVirtualVisitPending,
  selectCreateVirtualVisitError,
  selectVirtualVisitLocations,
} from '../../../redux/appointmentForm/selectors';
import styles from '../../DependentForm/styles.styl';

const mapStateToProps = state => ({
  loadingVisitTypes: selectVisitTypesPending(state),
  providersList: selectVirtualVisitProvidersList(state),
  isLoadingProviders: selectVirtualVisitProvidersPending(state),
  sendingCreateVisit: selectCreateVirtualVisitPending(state),
  errors: selectCreateVirtualVisitError(state),
  servicesList: selectVirtualVisitServicesList(state),
  reasonTypesList: selectReasonTypesList(state),
  loadingReasonTypes: selectReasonTypesPending(state),
  locations: selectVirtualVisitLocations(state),
});

const mapDispatchToProps = {
  fetchProviders: reqProviders.send,
  fetchVisitTypes: visitTypes.actions.send,
  clearVisitTypes: visitTypes.actions.clear,
  fetchReasonTypes: reasonTypes.actions.send,
  createVisit: createVirtualVisit.actions.init,
  clearCreateVisit: createVirtualVisit.actions.clear,
};

export const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withProps(({ loadingVisitTypes, sendingCreateVisit }) => ({
    pending: loadingVisitTypes || sendingCreateVisit,
  })),
  CSSModules(styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/VirtualVisit/VisitDetails/enhance.js